@if (activeLanguage === 'en') {
  <div class='warranty-announcement-block'>
    <h1>{{'warrentyLandingPageParagraph.page_announcement'|cxTranslate}}</h1>
    <p>{{'warrentyLandingPageParagraph.page_p1'|cxTranslate}}</p>
    <p>{{'warrentyLandingPageParagraph.page_p2'|cxTranslate}}
      <a [href]='latestDocUrl$ |async ' class='im-pdf-icon'
      target='_blank'>{{'warrentyLandingPageParagraph.hyperlinkText1'|cxTranslate}}</a>
    </p>
    <p>{{'warrentyLandingPageParagraph.page_p3'|cxTranslate}}
      <a href='mailto:warranty@bendix.com'>{{'warrentyLandingPageParagraph.hyperlinkText2'|cxTranslate}}</a>
    </p>
  </div>
}

<!-- fr_ca  -->
@if (activeLanguage === 'fr_CA') {
  <div class="AnnouncementsSection">
    <h1 class='warranty-info-title'>
    Centre d’informations de la garantie Bendix </h1>
    <div class='my-section-box'>
      <div class='warranty-info-box-heading'>
      Bienvenue au centre d’informations de la garantie Bendix.</div>
      <p>En votre qualité de client, vous pourrez présenter des réclamations sous garantie, voir l’état de la
        garantie,
        obtenir les politiques de garantie, utiliser notre NOUVEAU vérificateur d’admissibilité à la garantie…
        et
        plus
      encore!</p>
      <p>Vous devez être connecté à votre compte pour accéder aux liens suivants.</p>
      <ul>
        <li><a href='./my-account/submit-warranty'>Présenter des réclamations sous garantie </a></li>
        <li><a href='./my-account/search-warranty'>Rechercher l’historique des réclamations sous garantie </a>
      </li>
    </ul>
    <p>Acheteur original au détail : Tous les produits de freins à air comprimé vendus par Bendix Commercial
      Vehicle
      Systems LLC (« Bendix ») sont garantis pièces et main-d’œuvre pendant douze (12) mois; 100 000 milles
      (160
      000
    km); ou 3 600 heures, selon la première éventualité.</p>
    <p>Cette garantie limitée s’applique à tous les dispositifs, SAUF ceux déjà couverts par leur propre
      garantie
    limitée distincte.</p>
  </div>
</div>
}

<!-- ES_MX -->
@if (activeLanguage === 'es_MX') {
  <div class="AnnouncementsSection">
    <h1 class='warranty-info-title'> Bendix Warranty Information Center </h1>
    <div class='my-section-box'>
      <div class='warranty-info-box-heading'>Bienvenido al centro de información de garantía de Bendix</div>
      <p>Como cliente, podrá enviar reclamos de garantía, ver el estado de la garantía, obtener políticas de
        garantía,
      utilizar nuestro NUEVO verificador de elegibilidad de garantía…. ¡y mucho más!</p>
      <p>Debe iniciar sesión en su cuenta para acceder a los siguientes enlaces.</p>
      <ul>
        <li><a href='./my-account/submit-warranty'>Enviar reclamos de garantía </a></li>
        <li><a href='./my-account/search-warranty'>Buscar historial de reclamos de garantía </a></li>
      </ul>
      <p>Bendix Commercial Vehicle Systems LLC ('Bendix') garantiza al comprador minorista original de
        productos
        de
        frenos
        de aire que todos los productos vendidos por Bendix estarán libres de defectos en materiales o mano
        de
        obra
        durante doce (12) meses; 100,000 millas (160,000 kilómetros); o 3,600 horas, lo que ocurra primero.
      </p>
      <p>Esta garantía limitada se aplica a todos los dispositivos EXCEPTO a los dispositivos que están
        cubiertos
        por
        su
      propia garantía limitada separada</p>
    </div>
  </div>
}